import { allFonts } from '../../data/fonts';

import type { Fonts } from 'figlet';

let allFontsLoaded: Promise<typeof import('figlet')>;

async function importFontByName(name: string) {
  switch (name) {
    case 'Standard': {
      return import('figlet/importable-fonts/Standard');
    }
    case 'Big': {
      return import('figlet/importable-fonts/Big');
    }
    case 'Big': {
      return import('figlet/importable-fonts/Big');
    }
    case 'Bulbhead': {
      return import('figlet/importable-fonts/Bulbhead');
    }
    case 'ANSI Regular': {
      return import('figlet/importable-fonts/ANSI Regular');
    }
    case 'ANSI Shadow': {
      return import('figlet/importable-fonts/ANSI Shadow');
    }
    case 'Rectangles': {
      return import('figlet/importable-fonts/Rectangles');
    }
    case 'Ogre': {
      return import('figlet/importable-fonts/Ogre');
    }
    case 'Italic': {
      return import('figlet/importable-fonts/Italic');
    }
    case 'Slant': {
      return import('figlet/importable-fonts/Slant');
    }
    case 'Small': {
      return import('figlet/importable-fonts/Small');
    }
    case 'Stick Letters': {
      return import('figlet/importable-fonts/Stick Letters');
    }
    case 'Sub-Zero': {
      return import('figlet/importable-fonts/Sub-Zero');
    }
    case '3D-ASCII': {
      return import('figlet/importable-fonts/3D-ASCII');
    }
    case 'Ivrit': {
      return import('figlet/importable-fonts/Ivrit');
    }
    case 'AMC 3 Line': {
      return import('figlet/importable-fonts/AMC 3 Line');
    }
    case 'Broadway KB': {
      return import('figlet/importable-fonts/Broadway KB');
    }
    case 'Acrobatic': {
      return import('figlet/importable-fonts/Acrobatic');
    }
    case 'Serifcap': {
      return import('figlet/importable-fonts/Serifcap');
    }
    default: {
      console.error('Font name does not have a corresponding lazy import');
      throw 'Font name does not have a corresponding lazy import';
    }
  }
}

async function loadAsciiFonts() {
  if (!allFontsLoaded) {
    allFontsLoaded = new Promise(async (resolve, reject) => {
      try {
        const figlet = (await import('figlet')).default;
        const fontNames = Object.values(allFonts)
          .filter((f) => f.asciiFont)
          .map((f) => f.asciiFont);
        const fontsLoaded = fontNames.map(async (name) => {
          const font = await importFontByName(name);

          figlet.parseFont(name, font.default);
        });
        await Promise.all(fontsLoaded);
        resolve(figlet);
      } catch (err) {
        reject(err);
      }
    });
  }

  return allFontsLoaded;
}

export async function getAsciiText({ font, text }: { font: Fonts; text: string }) {
  const figlet = await loadAsciiFonts();

  return new Promise((resolve, reject) => {
    figlet.text(text, { font }, (err, data: string) => {
      if (err) {
        return reject(err);
      }
      resolve(data);
    });
  });
}
